
const secondAsMillis = 1000;
const minuteAsMillis = secondAsMillis * 60;
const hourAsMillis = minuteAsMillis * 60;
const dayAsMillis = hourAsMillis * 24;

/// Snapshot difference of time between start and end.
/// This is not intended to be used to manipulate dates and time
export class TimeSpan {
  private difference = 0;
  private _millis = 0;
  private _seconds = 0;
  private _minutes = 0;
  private _hours = 0;
  private _days = 0;

  private constructor(first: number, second: number) {
    // We don't care which order, simply calculate the difference
    this.difference = Math.abs(first - second);
    this.calc();
  }

  public get millis() {
    return this._millis;
  }

  public get seconds() {
    return this._seconds;
  }

  public get minutes() {
    return this._minutes;
  }

  public get hours() {
    return this._hours;
  }

  public get days() {
    return this._days;
  }

  private calc() {
    let consumableDifference = this.difference;

    const consumePart = (divideBy: number) => {
      let result = Math.floor(consumableDifference / divideBy);
      consumableDifference %= divideBy;
      return result;
    };

    this._days = consumePart(dayAsMillis);
    this._hours = consumePart(hourAsMillis);
    this._minutes = consumePart(minuteAsMillis);
    this._seconds = consumePart(secondAsMillis);
    this._millis = consumableDifference;
  }

  static fromDate(first: Date, second: Date): TimeSpan {
    return new TimeSpan(first.getTime(), second.getTime());
  }
}
